export const ACCOUNTS = [{
  id: 'acc_1',
  name: 'Nomsa Mokoena',
  msisdn: '+27821234567',
  ref: 'EDG-4421',
  balance: 487.5,
  status: 'active',
  lastContact: '2026-06-01T09:41:00Z'
}, {
  id: 'acc_2',
  name: 'Sipho Khumalo',
  msisdn: '+27739876543',
  ref: 'EDG-8812',
  balance: 1240.0,
  status: 'arrears',
  lastContact: '2026-05-28T14:20:00Z'
}, {
  id: 'acc_3',
  name: 'Anna Van Der Merwe',
  msisdn: '+27845551234',
  ref: 'TRU-1109',
  balance: 215.75,
  status: 'active',
  lastContact: '2026-06-02T08:15:00Z'
}, {
  id: 'acc_4',
  name: 'Thabo Ndlovu',
  msisdn: '+27612349876',
  ref: 'MRP-6633',
  balance: 0.0,
  status: 'settled',
  lastContact: '2026-05-30T11:05:00Z'
}, {
  id: 'acc_5',
  name: 'Lerato Dlamini',
  msisdn: '+27781112222',
  ref: 'FOS-7754',
  balance: 962.4,
  status: 'active',
  lastContact: '2026-06-01T16:45:00Z'
}, {
  id: 'acc_6',
  name: 'Johan Botha',
  msisdn: '+27823334444',
  ref: 'EDG-9921',
  balance: 350.0,
  status: 'active',
  lastContact: '2026-06-02T10:30:00Z'
}, {
  id: 'acc_7',
  name: 'Zanele Nkosi',
  msisdn: '+27715556666',
  ref: 'TRU-2244',
  balance: 1850.25,
  status: 'arrears',
  lastContact: '2026-05-25T09:00:00Z'
}, {
  id: 'acc_8',
  name: 'Pieter Nel',
  msisdn: '+27837778888',
  ref: 'MRP-1122',
  balance: 120.0,
  status: 'active',
  lastContact: '2026-06-02T11:15:00Z'
}];

// Possible failure reasons for failed transactions
export type FailureReason = 'timeout' | 'invalid_pin' | 'insufficient_funds' | 'network_error' | 'cancelled' | 'sim_swap_block';
export const FAILURE_REASON_LABELS: Record<FailureReason, string> = {
  timeout: 'Timeout',
  invalid_pin: 'Invalid PIN',
  insufficient_funds: 'Insufficient funds',
  network_error: 'Network error',
  cancelled: 'User cancelled',
  sim_swap_block: 'SIM-swap block'
};
export interface Transaction {
  id: string;
  ref: string;
  accountId: string;
  amount: number;
  channel: 'USSD' | 'WhatsApp' | 'SMS';
  status: 'settled' | 'pending' | 'failed' | 'processing';
  timestamp: string;
  responseTimeMs: number;
  failureReason?: FailureReason;
}
export const TRANSACTIONS: Transaction[] = [{
  id: 'tx_1',
  ref: 'MS-44218',
  accountId: 'acc_1',
  amount: 487.5,
  channel: 'USSD',
  status: 'settled',
  timestamp: '2026-06-02T09:42:00Z',
  responseTimeMs: 1240
}, {
  id: 'tx_2',
  ref: 'MS-44217',
  accountId: 'acc_2',
  amount: 500.0,
  channel: 'WhatsApp',
  status: 'pending',
  timestamp: '2026-06-02T09:41:00Z',
  responseTimeMs: 2980
}, {
  id: 'tx_3',
  ref: 'MS-44216',
  accountId: 'acc_3',
  amount: 215.75,
  channel: 'USSD',
  status: 'settled',
  timestamp: '2026-06-02T08:16:00Z',
  responseTimeMs: 980
}, {
  id: 'tx_4',
  ref: 'MS-44215',
  accountId: 'acc_4',
  amount: 150.0,
  channel: 'SMS',
  status: 'failed',
  timestamp: '2026-06-01T14:30:00Z',
  responseTimeMs: 30000,
  failureReason: 'timeout'
}, {
  id: 'tx_5',
  ref: 'MS-44214',
  accountId: 'acc_5',
  amount: 962.4,
  channel: 'WhatsApp',
  status: 'settled',
  timestamp: '2026-06-01T16:50:00Z',
  responseTimeMs: 1820
}, {
  id: 'tx_6',
  ref: 'MS-44213',
  accountId: 'acc_6',
  amount: 350.0,
  channel: 'USSD',
  status: 'settled',
  timestamp: '2026-06-02T10:35:00Z',
  responseTimeMs: 1150
}, {
  id: 'tx_7',
  ref: 'MS-44212',
  accountId: 'acc_8',
  amount: 120.0,
  channel: 'USSD',
  status: 'pending',
  timestamp: '2026-06-02T11:20:00Z',
  responseTimeMs: 4250
}, {
  id: 'tx_8',
  ref: 'MS-44211',
  accountId: 'acc_7',
  amount: 200.0,
  channel: 'USSD',
  status: 'failed',
  timestamp: '2026-06-02T11:05:00Z',
  responseTimeMs: 30000,
  failureReason: 'timeout'
}, {
  id: 'tx_9',
  ref: 'MS-44210',
  accountId: 'acc_2',
  amount: 75.0,
  channel: 'SMS',
  status: 'failed',
  timestamp: '2026-06-02T10:55:00Z',
  responseTimeMs: 4100,
  failureReason: 'invalid_pin'
}, {
  id: 'tx_10',
  ref: 'MS-44209',
  accountId: 'acc_3',
  amount: 845.0,
  channel: 'WhatsApp',
  status: 'processing',
  timestamp: '2026-06-02T11:18:00Z',
  responseTimeMs: 3120
}, {
  id: 'tx_11',
  ref: 'MS-44208',
  accountId: 'acc_5',
  amount: 1200.0,
  channel: 'USSD',
  status: 'failed',
  timestamp: '2026-06-02T08:42:00Z',
  responseTimeMs: 5300,
  failureReason: 'insufficient_funds'
}, {
  id: 'tx_12',
  ref: 'MS-44207',
  accountId: 'acc_1',
  amount: 300.0,
  channel: 'WhatsApp',
  status: 'settled',
  timestamp: '2026-06-02T07:30:00Z',
  responseTimeMs: 2010
}, {
  id: 'tx_13',
  ref: 'MS-44206',
  accountId: 'acc_6',
  amount: 95.0,
  channel: 'USSD',
  status: 'failed',
  timestamp: '2026-06-01T18:22:00Z',
  responseTimeMs: 30000,
  failureReason: 'timeout'
}, {
  id: 'tx_14',
  ref: 'MS-44205',
  accountId: 'acc_4',
  amount: 410.0,
  channel: 'SMS',
  status: 'settled',
  timestamp: '2026-06-01T19:10:00Z',
  responseTimeMs: 3800
}, {
  id: 'tx_15',
  ref: 'MS-44204',
  accountId: 'acc_7',
  amount: 525.0,
  channel: 'USSD',
  status: 'failed',
  timestamp: '2026-06-01T13:15:00Z',
  responseTimeMs: 6200,
  failureReason: 'network_error'
}, {
  id: 'tx_16',
  ref: 'MS-44203',
  accountId: 'acc_8',
  amount: 88.0,
  channel: 'WhatsApp',
  status: 'failed',
  timestamp: '2026-06-01T20:00:00Z',
  responseTimeMs: 1500,
  failureReason: 'cancelled'
}, {
  id: 'tx_17',
  ref: 'MS-44202',
  accountId: 'acc_5',
  amount: 175.0,
  channel: 'USSD',
  status: 'failed',
  timestamp: '2026-06-01T22:11:00Z',
  responseTimeMs: 30000,
  failureReason: 'timeout'
}, {
  id: 'tx_18',
  ref: 'MS-44201',
  accountId: 'acc_2',
  amount: 640.0,
  channel: 'USSD',
  status: 'failed',
  timestamp: '2026-06-01T16:33:00Z',
  responseTimeMs: 2200,
  failureReason: 'sim_swap_block'
}];
export const SETTLEMENTS = [{
  id: 'set_1',
  date: '2026-06-01',
  batchRef: 'STL-260601',
  amount: 45210.5,
  count: 142,
  status: 'completed'
}, {
  id: 'set_2',
  date: '2026-05-31',
  batchRef: 'STL-260531',
  amount: 38900.0,
  count: 115,
  status: 'completed'
}, {
  id: 'set_3',
  date: '2026-05-30',
  batchRef: 'STL-260530',
  amount: 51200.75,
  count: 168,
  status: 'completed'
}, {
  id: 'set_4',
  date: '2026-05-29',
  batchRef: 'STL-260529',
  amount: 42150.25,
  count: 130,
  status: 'completed'
}, {
  id: 'set_5',
  date: '2026-06-02',
  batchRef: 'STL-260602',
  amount: 12450.0,
  count: 45,
  status: 'processing'
}];
export const CHART_DATA = [{
  name: 'Mon',
  ussd: 4000,
  whatsapp: 2400,
  sms: 1000
}, {
  name: 'Tue',
  ussd: 3000,
  whatsapp: 1398,
  sms: 800
}, {
  name: 'Wed',
  ussd: 2000,
  whatsapp: 9800,
  sms: 1200
}, {
  name: 'Thu',
  ussd: 2780,
  whatsapp: 3908,
  sms: 1500
}, {
  name: 'Fri',
  ussd: 1890,
  whatsapp: 4800,
  sms: 900
}, {
  name: 'Sat',
  ussd: 2390,
  whatsapp: 3800,
  sms: 1100
}, {
  name: 'Sun',
  ussd: 3490,
  whatsapp: 4300,
  sms: 1300
}];

// Average response time per channel (in ms) over the last 7 days
export const RESPONSE_TIME_DATA = [{
  name: 'Mon',
  USSD: 1180,
  WhatsApp: 2100,
  SMS: 3450
}, {
  name: 'Tue',
  USSD: 1240,
  WhatsApp: 2240,
  SMS: 3680
}, {
  name: 'Wed',
  USSD: 1310,
  WhatsApp: 1980,
  SMS: 4120
}, {
  name: 'Thu',
  USSD: 1090,
  WhatsApp: 2050,
  SMS: 3550
}, {
  name: 'Fri',
  USSD: 1480,
  WhatsApp: 2380,
  SMS: 3920
}, {
  name: 'Sat',
  USSD: 1220,
  WhatsApp: 2110,
  SMS: 3380
}, {
  name: 'Sun',
  USSD: 1150,
  WhatsApp: 2030,
  SMS: 3490
}];

// Aggregated failure reasons across the last 30 days
export const FAILURE_BREAKDOWN = [{
  reason: 'Timeout',
  key: 'timeout',
  count: 142,
  pct: 48
}, {
  reason: 'Invalid PIN',
  key: 'invalid_pin',
  count: 58,
  pct: 19
}, {
  reason: 'Insufficient funds',
  key: 'insufficient_funds',
  count: 41,
  pct: 14
}, {
  reason: 'Network error',
  key: 'network_error',
  count: 28,
  pct: 9
}, {
  reason: 'User cancelled',
  key: 'cancelled',
  count: 18,
  pct: 6
}, {
  reason: 'SIM-swap block',
  key: 'sim_swap_block',
  count: 11,
  pct: 4
}];